// REUSABLE CONSTANTS

// Reusable Arrays
const PROVINCES = [
	{ value: "", text: "Province" },
	{ value: "AB", text: "Alberta" },
	{ value: "BC", text: "British Columbia" },
	{ value: "MB", text: "Manitoba" },
	{ value: "NB", text: "New Brunswick" },
	{ value: "NL", text: "Newfoundland" },
	{ value: "NS", text: "Nova Scotia" },
	{ value: "NT", text: "Northwest Territories" },
	{ value: "NU", text: "Nunavut" },
	{ value: "ON", text: "Ontario" },
	{ value: "PE", text: "Prince Edward Island" },
	{ value: "QC", text: "Quebec" },
	{ value: "SK", text: "Saskatchewan" },
	{ value: "YT", text: "Yukon" }
];

// const ILLEGAL_CHARACTERS = ['<', '>', '?', ',', "'", '"', '@', '!', '#', '$', '%', '^', '&', '*', '(', ')', '/'];
const ILLEGAL_CHARACTERS = ['<', '>', '?', "'", '"', '@', '!', '#', '$', '%', '^', '&', '*'];
const ROAD_SUFFIXES = ['AVE', 'HTS', 'BLVD', 'CRT', 'CRST', 'RD', 'ST', 'PL', 'PKWY', 'GATE', 'WAY', 'TRAIL', 'TERR', 'CIR', 'WALK', 'LN', 'LANE']
// Default formData Object
const DEFAULT_FORMDATA = {
	Manager2FirstName: "",
	Manager2LastName: "",
	Manager2Email: "",
	Manager2Phone: "",
	Id: "",
	CompanyName: "",
	CompanyEmail: "",
	CompanyPhone: "",
	CompanyAddressLine1: "",
	CompanyAddressLine2: "",
	CompanyAddress: "",
	CompanyCity: "",
	CompanyProvince: "",
	CompanyPostalCode: "",
	CompanyCountry: "Canada",
	CompanyContactId: "",
	ProductionType: "",
	ProductionTitle: "",
	ProductionType_EpisodeNumber: "",
	ProductionType_Other: "",
	Prep_StartDate: "",
	Prep_EndDate: "",
	Filming_StartDate: "",
	Filming_EndDate: "",
	Wrap_StartDate: "",
	Wrap_EndDate: "",
	Weather_Date: "",
	NumOfVehicles: "",
	NumOfCastCrew: "",
	TOTALPRODBUDGET: "",
	TOTCADCB: "Y",
	TOTALUSDCB: "N",
	ESTSPEND: "",
	ESTCADCB: "Y",
	ESTUSDCB: "N",
	Consent_CityCredit: 'N',
	FILMINTERIOR: 'N',
	FILMEXT: "N",
	FILMFRONT: "N",
	FILMBACK: "N",
	FILMOTHER: "N",
	EQRW: "N",
	EQBLVD: "N",
	EQSW: "N",
	CAMCAR: "N",
	CityGrid: "N",
	TOWRIG: "N",
	VEHPULLUP: "N",
	VEHPULLLOC: "",
	TRAVSHOOT: "N",
	TRVSHOTLOC: "",
	TRAFSTOP: "N",
	UserEmail: "",
	POLSTOPLOC: "", //Traffic stop location
	FX: "N",
	SPFXDESC: "",
	UAV: "N",
	SPECINSTR: "",
	Facility_Building_Name: "",
	Facility_Building_StartDate: '',
	Facility_Building_EndDate: '',
	Facility_Park_Name: '',
	Facility_Park_StartDate: '',
	Facility_Park_EndDate: '',
	SelectedFilmingLocationList: [
		{ AddressName: '', AddressNumber: '', AddressKey: '' },
		{ AddressName: '', AddressNumber: '', AddressKey: '' }
	],
	SelectedStreetRoadList: [
		/*
		{
			"StreetRoad": "ABRUZ BLVD",
			"Intersection_From": "ABRUZ BLVD/ALTERSEN PL",
			"Intersection_To": "ABRUZ BLVD/OLD PHEASANT RD",
			"StreetRoadStartDate": "2019-05-08 00:00:01",
			"StreetRoadEndDate": "2019-05-08 00:00:01",
			"StreetRoadSide": "",
			"StreetRoadUseType": "parking"
		}
		*/
	],
	SelectedParkingLocationList: [
		/*
		{
			"Location": "Parking Location 01",
			"NumOfSpaces": 0,
			"LocationStartDate": "2019-01-01 00:00:01",
			"LocationEndDate": "2019-01-02 00:00:01",
			"Private": "N",
			"OverNight": "N"
		}
		*/
	],
	Agreement: "N",
	Recaptcha_Token: "",

	

}

const GRID_RESET = {
	Facility_Building_Name: "",
	Facility_Building_StartDate: '',
	Facility_Building_EndDate: '',
	Facility_Park_Name: '',
	Facility_Park_StartDate: '',
	Facility_Park_EndDate: '',
	SelectedFilmingLocationList: [
		{ AddressName: '', AddressNumber: '', AddressKey: '' },
		{ AddressName: '', AddressNumber: '', AddressKey: '' }
	],
	SelectedStreetRoadList: [
		/*
		{
			"StreetRoad": "ABRUZ BLVD",
			"Intersection_From": "ABRUZ BLVD/ALTERSEN PL",
			"Intersection_To": "ABRUZ BLVD/OLD PHEASANT RD",
			"StreetRoadStartDate": "2019-05-08 00:00:01",
			"StreetRoadEndDate": "2019-05-08 00:00:01",
			"StreetRoadSide": "",
			"StreetRoadUseType": "parking"
		}
		*/
	],
	SelectedParkingLocationList: [
		/*
		{
			"Location": "Parking Location 01",
			"NumOfSpaces": 0,
			"LocationStartDate": "2019-01-01 00:00:01",
			"LocationEndDate": "2019-01-02 00:00:01",
			"Private": "N",
			"OverNight": "N"
		}
		*/
	]
}

export {
	PROVINCES,
	ILLEGAL_CHARACTERS,
	DEFAULT_FORMDATA,
	ROAD_SUFFIXES,
	GRID_RESET
}